import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react";
import { useStore } from "../../../../../hooks";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";

import { Container } from './RoleTable.styled';
import { defaultTableConfig, generateColumnTable } from "../../../../../utils/tableUtils";
import CustomPagination from "../../../../../elements/v2/CustomPagination/CustomPagination";

const RolesTable = observer(({ searchValue }) => {
  const { listRoleStore, authStore } = useStore();
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState(listRoleStore.roles);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });

  useEffect(() => {
    listRoleStore.setCustomer(authStore.selectedAccount.id)
    listRoleStore.onFetchRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.selectedAccount.id]);

  useEffect(() => {
    const filtered = listRoleStore.roles.filter(row =>
      row.name?.toLowerCase()?.includes(searchValue.toLowerCase()) || row.description?.toLowerCase()?.includes(searchValue.toLowerCase()) || row.access?.toLowerCase()?.includes(searchValue.toLowerCase())
    );
    setFilteredData(filtered);
    setPagination(prev => ({ ...prev, pageIndex: 0 })); // Reset pagination when search changes
  }, [listRoleStore.roles, searchValue]);

  const columns = useMemo(
    () => [
      generateColumnTable("name", "Role Name"),
      {
        ...generateColumnTable("description", "Description"),
        size: 400,
        minSize: 300,
        maxSize: 600,
        Cell: ({ cell }) => (
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {cell.getValue()}
          </span>
        ),
      },
    ],
    []
  );

  const handleRowClick = (row) => {
    navigate(`/v2/roles/details/${row.original.id}`);
  };

  const table = useMaterialReactTable({
    columns,
    data: filteredData,
    rowCount: filteredData.length,
    initialState: { isHidden: { countryCode: true } },
    createDisplayMode: "modal",
    editDisplayMode: "modal",
    enableEditing: false,
    getRowId: (row) => row.id,
    positionActionsColumn: 'last',
    renderBottomToolbar: (props) => <CustomPagination table={props.table} />,
    muiTablePaginationProps: false,
    enableStickyFooter: true,
    enablePagination: true,
    enableRowSelection: false,
    state: {
      pagination,
      isLoading: listRoleStore.status === "loading",
    },
    onPaginationChange: setPagination,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: () => handleRowClick(row),
      sx: {
        cursor: 'pointer',
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
      },
    }),
    ...defaultTableConfig,
    muiTableContainerProps: {
      sx: {
        borderBottom: "1px solid #E0E0E0",
        margin: "20px",
        marginTop: "10px",
        flex: 1,
        minHeight: 0,
      },
    },
  });

  return (
    <Container>
      <MaterialReactTable table={table} />
    </Container>
  );
});

export default RolesTable;
